// Manual catching on the hunt scene: click (or tap) a defeated wild that still has its throw, and a seal goes at it
// now, whatever Throw at says. The server checks everything (server/hunt.ts throwAt); this only finds the body under
// the pointer, shows a pointer cursor over it, and keeps a double click from asking twice.
import type { ClientMsg } from '../shared/protocol.ts';
import { catchableAt, setCatchHover, wayfarerAt, signpostAt } from './field.ts';
import { openProfileCard } from './profilecard.ts';
import { throwStepShowing } from './tutorial.ts';

/** Bodies already asked for, with when: the server's answer arrives within a tick or two. */
const asked = new Map<number, number>();
const ASK_MS = 2000;
const skip = (uid: number) => (asked.get(uid) ?? 0) > Date.now() - ASK_MS;

export function mountManualCatch(canvas: HTMLCanvasElement, send: (m: ClientMsg) => void) {
  canvas.addEventListener('pointermove', (e) => {
    const uid = e.pointerType === 'mouse' ? catchableAt(e.clientX, e.clientY, skip) : null;
    setCatchHover(uid);
    canvas.style.cursor = uid !== null || (e.pointerType === 'mouse' && (wayfarerAt(e.clientX, e.clientY) || signpostAt(e.clientX, e.clientY))) ? 'pointer' : '';
  });
  canvas.addEventListener('pointerleave', () => { setCatchHover(null); canvas.style.cursor = ''; });
  canvas.addEventListener('click', (e) => {
    // The tutorial's throw step takes a tap anywhere on the scene: on a phone a beaten wild is a small target that
    // drifts to the edge as the team moves on, and new players left without a single catch.
    const uid = catchableAt(e.clientX, e.clientY, skip, throwStepShowing());
    // Another trainer on the hunt: their trainer card.
    if (uid === null) { const who = wayfarerAt(e.clientX, e.clientY); if (who) openProfileCard(who); return; }
    for (const [k, at] of asked) if (at < Date.now() - ASK_MS) asked.delete(k);
    asked.set(uid, Date.now());
    setCatchHover(null);
    canvas.style.cursor = '';
    send({ t: 'catch', uid });
  });
}
